/* eslint-disable no-unneeded-ternary */
import React from 'react'
import Highlights from './HighlightsGrid'
import FourColumnContainer from './FourColumn'
import { Grid } from './Grid.styles'
import Integrations from './integrationsGrid'
import ThreeColumnContainer from './ThreeColumnContainer'

export default function GridContainer({ title, grid, content, filterSet, border, center }) {
	return (
		<Grid className="grid-container">
			<>
				{grid === 'integrations' && <Integrations connectors={content} filterSet={filterSet} border={border} />}
			</>
			<>
				{grid === 'threeColumn' && (
					<ThreeColumnContainer
						title={title}
						content={content}
						filterSet={filterSet}
						border={border}
						center={center}
					/>
				)}
			</>
			<>
				{grid === 'fourColumn' && (
					<FourColumnContainer
						title={title}
						content={content}
						filterSet={filterSet}
						border={border}
						center={center}
					/>
				)}
			</>
			<>
				{(grid === 'twoColumnHighlights' ||
					grid === 'threeColumnHighlights' ||
					grid === 'fourColumnHighlights') && (
					<Highlights title={title} content={content} border={border} center={center} gridValue={grid} />
				)}
			</>
		</Grid>
	)
}
